// extracted by mini-css-extract-plugin
export default {"mainCont":"VolumeList_mainCont__d3xUH","title":"VolumeList_title__rA2PW","ldr":"VolumeList_ldr__eMn7E","ldrCont":"VolumeList_ldrCont__mtvb1","ldrTitle":"VolumeList_ldrTitle__wqZZ-"};